import t from '@jetshop/intl';
import ProductGridWindow from '../CategoryPage/ProductGridWindow';
import React from 'react';
import { styled } from 'linaria/react';
import searchQuery from './SearchQuery.gql';
import qs from 'qs';
import { TrendLink } from '../ui/Button';
import { useLocation } from 'react-router';
import useInfinitePagination from '@jetshop/core/hooks/useInfinitePagination';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import { theme } from '../Theme';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import CategoryLink from '@jetshop/ui/CategoryLink';
import FilterDrawer from '../CategoryPage/Filters/FilterDrawer';
import { SortOrders } from '../CategoryPage/Filters/SortOrders';
import Filters from '../CategoryPage/Filters';

const Matches = styled('div')`
  padding-bottom: 1.5rem;

  > div {
    font-weight: 500;
  }
`;

const ButtonWrapper = styled('div')`
  width: 100%;
  max-width: 16rem;
  margin: 1rem auto;
`;

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
`;

const InnerFilterWrapper = styled('div')`
  ul {
    margin: 0;
    padding: 0;
    margin-bottom: 20px;
  }

  input {
    margin: 0 5px 0 0;
  }

  li,
  p {
    font-family: ${theme.fonts.primaryFontFamily};
    font-weight: 400;
    font-size: 14px;
    line-height: 25px;
    color: #282828;
    list-style-type: none;
  }
  .filter-name {
    display: flex;
    justify-content: space-between;

    h4 {
      font-family: ${theme.fonts.primaryFontFamily};
      font-weight: 700;
      font-size: 12px;
      line-height: 17px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #282828;
      margin: 0 0 10px 0;
    }
    border-top: 1px solid #ededed;
    padding-top: 16px;
  }
`;

const FiltersWrapper = styled('aside')`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  max-width: 18%;
  height: 100%;
  width: 100%;
  position: sticky;
  top: 136px;
`;

const CatgoryInnerWrapper = styled('div')`
  margin-top: 20px;

  ${theme.below.lg} {
    max-width: 100%;
  }
`;

const SearchPageWrapper = styled('main')`
  width: 100%;
  /* max-width: 80%; */
  ${theme.below.lg} {
    max-width: 100%;
  }
`;

const SearchHeaderWrapper = styled('div')`
  h1 {
    font-family: ${theme.fonts.primaryFontFamily};
    font-weight: 700;
    font-size: 43px;
    line-height: 52px;
    margin: 6px 0 0 !important;
    color: #282828;
  }

  p {
    margin: 10px 0;
  }

  ${theme.below.lg} {
    margin: 0 10px;
    h1 {
      font-size: 28px;
      line-height: 34px;
    }
  }
`;

const CategoriesLinksWrapper = styled('div')`
  margin-top: 6px;
  margin-bottom: 40px;

  p {
    font-weight: 500;
  }

  ${theme.below.lg} {
    padding: 0 10px;
    margin-bottom: 20px;
  }
`;

const CategoryNavigation = styled('div')`
  display: flex;
  flex-wrap: wrap;

  ${theme.below.lg} {
    flex-wrap: nowrap;
    /* padding: 0 20px; */
    /* margin: 17px 0; */
    overflow-x: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;

const CategoryNavigationItem = styled(CategoryLink)`
  padding: 13px 30px 9px;
  background: ${theme.colors.grey};
  color: ${theme.colors.darkgrey};
  margin-right: 10px;
  margin-top: 10px;
  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  border-radius: ${theme.button.desktop.borderRadius};

  ${theme.below.lg} {
    width: 100%;
    min-width: fit-content;
    text-align: center;
  }
`;

const SortWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  ${theme.below.lg} {
    justify-content: space-between;
    padding: 0 10px;
  }
`;

const CategoriesLinks = ({ searchedCategories }) => {
  return (
    <>
      <CategoryNavigation>
        {searchedCategories?.map(category => {
          return (
            <CategoryNavigationItem key={category.id} category={category}>
              {category?.name}
            </CategoryNavigationItem>
          );
        })}
      </CategoryNavigation>
    </>
  );
};

const WindowedSearchResults = ({ loading, ...props }) => {
  const { total, term, result } = props;

  const { currentPage } = React.useContext(PaginationContext);
  const search = result?.data?.search;
  const location = useLocation();
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });

  const { products, previous, next } = useInfinitePagination({
    result,
    query: searchQuery
  });

  return (
    <Wrapper>
      <Above breakpoint="md">
        {matches =>
          matches && (
            <FiltersWrapper>
              <>
                {search?.products?.result?.length > 0 ? (
                  <>
                    <Matches>
                      {loading ? (
                        currentPage === 1 ? (
                          <div>
                            {t(`Loading search results for {term}…`, {
                              term
                            })}
                          </div>
                        ) : (
                          <div>
                            {t(`Loading page {currentPage}…`, {
                              currentPage
                            })}
                          </div>
                        )
                      ) : (
                        <div>
                          {t(
                            'Showing {total, plural, =1 {# item} other {# items}}',
                            {
                              total,
                              term
                            }
                          )}
                        </div>
                      )}
                    </Matches>
                    <InnerFilterWrapper className="filters-wrapper">
                      <FilterDrawer
                        close={null}
                        filters={search?.products?.filters || []}
                        sortOrders={search?.products?.sortOrders || []}
                      />
                    </InnerFilterWrapper>
                  </>
                ) : (
                  <div />
                )}
              </>
            </FiltersWrapper>
          )
        }
      </Above>
      <SearchPageWrapper>
        <SearchHeaderWrapper>
          <h1>
            {t('You searched on ')}
            {term}
          </h1>
        </SearchHeaderWrapper>
        {search?.categories?.result?.length > 0 && (
          <CategoriesLinksWrapper>
            <p>Kategoriresultat</p>
            <CategoriesLinks searchedCategories={search?.categories?.result} />
          </CategoriesLinksWrapper>
        )}
        <SortWrapper>
          <Below breakpoint="lg">
            {matches =>
              matches && (
                <Filters
                  filters={search?.products?.filters || []}
                  sortOrders={search?.products?.sortOrders || []}
                />
              )
            }
          </Below>
          <SortOrders sortOrders={search?.products?.sortOrders || []} />
        </SortWrapper>
        <CatgoryInnerWrapper>
          {previous.hasProducts && (
            <ButtonWrapper>
              <TrendLink
                secondary
                onClick={e => {
                  e.preventDefault();
                  previous.fetchProducts();
                }}
                to={{
                  ...location,
                  search: qs.stringify({
                    ...params,
                    page: previous.page
                  })
                }}
              >
                {t('Show more')}
              </TrendLink>
            </ButtonWrapper>
          )}
          <ProductGridWindow
            id="search"
            prevOffset={previous.offset}
            products={products}
            listName={'search'}
            loading={result.loading}
            imageSizes={[1 / 2, 1 / 2, 1 / 3, 1 / 4]}
          />
          {next.hasProducts && (
            <ButtonWrapper>
              <TrendLink
                secondary
                onClick={e => {
                  e.preventDefault();
                  next.fetchProducts();
                }}
                to={{
                  ...location,
                  search: qs.stringify({
                    ...params,
                    page: next.page
                  })
                }}
              >
                {t('Show more')}
              </TrendLink>
            </ButtonWrapper>
          )}
        </CatgoryInnerWrapper>
      </SearchPageWrapper>
    </Wrapper>
  );
};

export default WindowedSearchResults;
